import React, { useEffect, useState } from 'react';
import Input from '../shared/Input';
import ContactInput from '../shared/Contact-Input';
import useMediaQuery from './useMediaQuery';

const imageArray = [
  { id: 1, url: 'https://res.cloudinary.com/dm80mcqzl/image/upload/v1748601559/Group_2_jnkfqu.png' },
  { id: 2, url: 'https://res.cloudinary.com/dm80mcqzl/image/upload/v1748619123/Group_2_jnkfqu.png' },
  { id: 3, url: 'https://res.cloudinary.com/dm80mcqzl/image/upload/v1748619188/Group_2_jnkfqu.png' },
];

const Investor = () => {
  const [fadeOut, setFadeOut] = useState(false);
  const [currentImage, setCurrentImage] = useState(0);
  const isMobile = useMediaQuery('(max-width: 1023px)');

  useEffect(() => {
    const fadeTimer = setTimeout(() => {
      setFadeOut(true);
    }, 6000);

    const imageTimer = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % imageArray.length);
    }, 2000);

    return () => {
      clearTimeout(fadeTimer);
      clearInterval(imageTimer);
    };
  }, []);

  const background = (
    <div className="absolute inset-0 overflow-hidden z-10">
      <div
        className="absolute w-[520px] h-[520px] rounded-full opacity-12"
        style={{
          background:
            'radial-gradient(circle, #16A0AA80 50%, #02020200 -30%, rgba(0, 217, 255, 0.15) 5%, transparent 20%)',
          filter: 'blur(42px)',
          animation: 'moveCircle6 15s ease-in-out infinite',
        }}
      />
    </div>
  );

  const footer = (
    <div className="relative z-10 flex lg:flex-row 2xl:flex-row flex-col items-center justify-around w-full px-4 pb-10">
      <p className="font-[600] text-[14px] text-[#333333] mt-4 lg:mt-0">@2025 Sporthub</p>
    </div>
  );

  return (
    <div className="relative lg:min-h-screen 2xl:min-h-screen min-h-auto h-[800px] lg:h-auto 2xl:h-auto bg-[#0E0E0E] text-white pt-[3rem] overflow-x-hidden overflow-y-auto flex flex-col justify-between">
      {background}

      {isMobile ? (
        // ✅ Mobile View
        <div className="relative z-10 flex flex-col-reverse items-center justify-around w-full px-4 animate-fade-in delay-[1000ms]">
          {/* Left Side */}
          <div className="max-w-[38rem] w-full pb-10 px-4 lg:px-0 2xl:px-0">
            <h1 className="text-[32px] font-bold my-6 animate-fade-in delay-[1200ms]">
              Something Big Is Coming to the World of Sport.
            </h1>
            <p className="text-lg font-semibold mb-2 animate-fade-in delay-[1400ms]">
              Want to stay in the loop?
            </p>
            <p className="text-gray-400 mb-6 animate-fade-in delay-[2000ms]">
              Discover how your investment can power a game-changing platform for the global sports community.
            </p>
            <ContactInput />
            <p className="text-xs text-gray-500 animate-fade-in delay-[2500ms]">
              (You will get notified at launch)
            </p>
            <p className="text-[14px] font-[400] text-[#A7A7A7] mt-6 animate-fade-in delay-[3000ms]">
              ❤️ Built in Canada, for sports communities worldwide.
            </p>
          </div>

          {/* Image */}
          <div className="flex items-start transition-opacity duration-700 ease-in-out mb-6">
            <img
              src={imageArray[currentImage]?.url}
              className="object-cover w-[195px] h-[261px]"
              alt={`Athlete ${currentImage + 1}`}
              key={currentImage}
            />
          </div>
        </div>
      ) : (
        // ✅ Desktop View (your full original JSX untouched)
        <div className="relative z-10 flex flex-col flex-col-reverse lg:flex-row items-center justify-around w-full px-4 animate-fade-in delay-[1000ms]">
          {/* Left Side */}
          <div className="max-w-[38rem] pr-[0.5rem] w-full pb-10 lg:pb-0 lg:h-[calc(100vh-180px)] 2xl:h-[calc(100vh-180px)] h-[calc(100vh-80px)] lg:overflow-hidden 2xl:overflow-hidden overflow-auto hover:overflow-y-auto scrollbar-hide custom-scrollbar">
            <h1 className="lg:text-[48px] text-[32px] font-bold my-6 animate-fade-in delay-[1200ms]">
              Something Big Is Coming to the World of Sport.
            </h1>
            <p className="text-lg font-semibold mb-2 animate-fade-in delay-[1400ms]">
              Want to stay in the loop?
            </p>
            <p className="text-gray-400 mb-6 animate-fade-in delay-[2000ms]">
              Discover how your investment can power a game-changing platform for the global sports community.
            </p>
            <ContactInput />
            <p className="text-xs text-gray-500 animate-fade-in delay-[2500ms]">
              (You will get notified at launch)
            </p>
            <p className="text-[14px] font-[400] text-[#A7A7A7] mt-6 animate-fade-in delay-[3000ms]">
              ❤️ Built in Canada, for sports communities worldwide.
            </p>
          </div>

          {/* Image Rotator */}
          <div className="flex items-start  transition-opacity duration-700 ease-in-out">
            <img
              src={imageArray[currentImage]?.url}
              className="object-cover lg:w-[421px] lg:h-[564px] w-[195px] h-[261px]"
              alt={`Athlete ${currentImage + 1}`}
              key={currentImage}
            />
          </div>
        </div>
      )}

      {footer}
    </div>
  );
};

export default Investor;
